module.exports = __webpack_public_path__ + "static/banner-mobile-f76176d1212b73708cd1d611932fee8a.jpg";